import React, { useState } from 'react';

export default function SplitPayment({ totalAmount, paidAmount, onPayAmount }) {
  const [mode, setMode] = useState('equal');
  const [numPeople, setNumPeople] = useState(2);
  const [customAmount, setCustomAmount] = useState('');

  const remaining = totalAmount - paidAmount;
  const equalShare = Math.ceil(totalAmount / numPeople);
  const myShare = mode === 'equal' ? Math.min(equalShare, remaining) : Number(customAmount) || 0;

  const handleConfirm = () => {
    if (myShare <= 0 || myShare > remaining) return;
    onPayAmount(myShare);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Mode tabs */}
      <div
        style={{
          display: 'flex',
          background: 'var(--border)',
          borderRadius: 'var(--radius-md)',
          padding: 4,
          gap: 4,
        }}
      >
        {[
          { id: 'equal', label: 'N분의 1' },
          { id: 'custom', label: '직접 입력' },
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setMode(tab.id)}
            style={{
              flex: 1,
              padding: '10px 0',
              borderRadius: 'var(--radius-sm)',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font)',
              fontWeight: 600,
              fontSize: 14,
              transition: 'all 0.15s ease',
              background: mode === tab.id ? 'var(--surface)' : 'transparent',
              color: mode === tab.id ? 'var(--primary)' : 'var(--text-tertiary)',
              boxShadow: mode === tab.id ? 'var(--shadow-sm)' : 'none',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {mode === 'equal' ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ fontSize: 14, color: 'var(--text-tertiary)', fontWeight: 500 }}>
            인원 수 선택
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 24,
            }}
          >
            <button
              className="qty-btn"
              onClick={() => setNumPeople(Math.max(2, numPeople - 1))}
              style={{
                width: 44,
                height: 44,
                background: 'var(--border)',
                borderRadius: '50%',
                fontSize: 20,
              }}
            >
              -
            </button>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <span style={{ fontSize: 32, fontWeight: 800, color: 'var(--primary)' }}>
                {numPeople}
              </span>
              <span style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>명</span>
            </div>
            <button
              className="qty-btn"
              onClick={() => setNumPeople(Math.min(10, numPeople + 1))}
              style={{
                width: 44,
                height: 44,
                background: 'var(--border)',
                borderRadius: '50%',
                fontSize: 20,
              }}
            >
              +
            </button>
          </div>

          <div
            style={{
              background: 'var(--primary-light)',
              borderRadius: 'var(--radius-md)',
              padding: '14px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span style={{ fontSize: 14, color: 'var(--primary)', fontWeight: 600 }}>
              1인 부담금
            </span>
            <span style={{ fontSize: 20, fontWeight: 800, color: 'var(--primary)' }}>
              {equalShare.toLocaleString()}원
            </span>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ fontSize: 14, color: 'var(--text-tertiary)', fontWeight: 500 }}>
            결제할 금액 입력 (최대 {remaining.toLocaleString()}원)
          </div>
          <div style={{ position: 'relative' }}>
            <input
              type="number"
              value={customAmount}
              onChange={(e) => {
                const val = Math.min(Number(e.target.value), remaining);
                setCustomAmount(val || '');
              }}
              placeholder="금액을 입력하세요"
              min={0}
              max={remaining}
              style={{ paddingRight: 40, fontSize: 16 }}
            />
            <span
              style={{
                position: 'absolute',
                right: 16,
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--text-tertiary)',
                fontWeight: 600,
              }}
            >
              원
            </span>
          </div>
        </div>
      )}

      <button
        className="btn btn-primary btn-block"
        onClick={handleConfirm}
        disabled={myShare <= 0 || myShare > remaining}
        style={{ marginTop: 4 }}
      >
        {myShare > 0
          ? `${myShare.toLocaleString()}원 결제하기`
          : '이 금액 결제'}
      </button>
    </div>
  );
}
